import { neutralWhite, primary800 } from '../themes/colors';

export const buttonVariants = [
	'default',
	'white',
	'dark',
] as const;

export type TooltipVariant = typeof buttonVariants[number];

export type TooltipColorDefinition = {
	background: string,
	color: string,
	border: string,
}

export const TooltipColors: {[key in TooltipVariant]: TooltipColorDefinition} = {
	default: {
		background: primary800,
		color: neutralWhite,
		border: primary800,
	},
	white: {
		background: neutralWhite,
		color: primary800,
		border: neutralWhite,
	},
	dark: {
		background: primary800,
		color: neutralWhite,
		border: primary800,
	},
};
